import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
} from '@angular/core';
import { CardComponent, CardLevel } from '@freelancer/ui/card';
import { DisplayCardContentComponent } from './display-card-content.component';
import { DisplayCardFooterLeftComponent } from './display-card-footer-left.component';
import { DisplayCardFooterRightComponent } from './display-card-footer-right.component';
import { DisplayCardHeaderLeftComponent } from './display-card-header-left.component';
import { DisplayCardHeaderRightComponent } from './display-card-header-right.component';
import { DisplayCardImageComponent } from './display-card-image.component';

@Component({
  standalone: true,
  selector: 'fl-display-card',
  imports: [CardComponent],
  template: `
    <fl-card
      class="Card"
      [edgeToEdge]="true"
      [level]="level"
      [maxContent]="false"
    >
      <div
        [class.Header]="headerLeftContent || headerRightContent"
        [class.HeaderRightOnly]="headerRightContent && !headerLeftContent"
      >
        <ng-content select="fl-display-card-header-left"></ng-content>
        <ng-content select="fl-display-card-header-right"></ng-content>
      </div>

      <div [class.ImageContainer]="imageContent">
        <ng-content select="fl-display-card-image"></ng-content>
      </div>

      <div [class.Content]="cardContent">
        <ng-content select="fl-display-card-content"></ng-content>
      </div>

      <div
        [class.Footer]="footerLeftContent || footerRightContent"
        [class.FooterRightOnly]="footerRightContent && !footerLeftContent"
      >
        <ng-content select="fl-display-card-footer-left"></ng-content>
        <ng-content select="fl-display-card-footer-right"></ng-content>
      </div>
    </fl-card>
  `,
  styleUrls: ['./display-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayCardComponent {
  @Input() level: CardLevel = 'primary';

  @ContentChild(DisplayCardHeaderRightComponent)
  headerRightContent: DisplayCardHeaderRightComponent;

  @ContentChild(DisplayCardHeaderLeftComponent)
  headerLeftContent: DisplayCardHeaderLeftComponent;

  @ContentChild(DisplayCardImageComponent)
  imageContent: DisplayCardImageComponent;

  @ContentChild(DisplayCardContentComponent)
  cardContent: DisplayCardContentComponent;

  @ContentChild(DisplayCardFooterLeftComponent)
  footerLeftContent: DisplayCardFooterLeftComponent;

  @ContentChild(DisplayCardFooterRightComponent)
  footerRightContent: DisplayCardFooterRightComponent;
}
